export type SeatStatus = "available" | "own" | "occupied";

/** 座席ステータスごとの背景・ボーダースタイル */
export const seatStatusStyles: Record<SeatStatus, string> = {
  available: "bg-green-500/50 hover:bg-green-500/70 border-green-600",
  own: "bg-primary-600/70 hover:bg-primary-600/90 border-primary-700",
  occupied: "bg-gray-400/50 hover:bg-gray-400/70 border-gray-500",
};

/** 座席ステータスごとのテキスト色 */
export const seatStatusTextStyles: Record<SeatStatus, string> = {
  available: "text-green-900",
  own: "text-white",
  occupied: "text-gray-700",
};

/** SeatLegend 用の凡例表示スタイル（小さな色ボックス向け） */
export const seatLegendStyles: Record<SeatStatus, string> = {
  available: "bg-green-500/50 border-green-600",
  own: "bg-primary-600/70 border-primary-700",
  occupied: "bg-gray-400/50 border-gray-500",
};
